import {FileMime} from 'shared/models/file.mime';

export interface FileData<T extends FileMime> {
    id: string,
    label: string,
    filemime: T,
    uri: URL | string,
    self: URL | string,
}